import { createStore, createSelectors } from "@kanda-libs/ks-frontend-services";
import { type PageKeys, pages } from "components/shared/App";
import query, { QueryState } from "./slices/query";

export interface ExtraState {
  query: QueryState;
}

export const store = createStore<PageKeys>({ query });

store.subscribe(() => {
  console.log("State changed", store.getState());
});

export type RootState = ReturnType<typeof store.getState> & ExtraState;
export type AppDispatch = typeof store.dispatch;

export const selectors = createSelectors<RootState, typeof pages>();
